import {
  CloseCircleOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";

export const ClearIcon = CloseCircleOutlined;
export const EyeIcon = EyeOutlined;
export const EyeInvisibleIcon = EyeInvisibleOutlined;
export const IconArrowDown = DownOutlined;
export const SearchIcon = SearchOutlined;
